import { render, staticRenderFns } from "./RotatableCardFace.vue?vue&type=template&id=881db94c&scoped=true&"
import script from "./RotatableCardFace.vue?vue&type=script&lang=js&"
export * from "./RotatableCardFace.vue?vue&type=script&lang=js&"
import style0 from "./RotatableCardFace.vue?vue&type=style&index=0&id=881db94c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881db94c",
  null
  
)

export default component.exports